import {localStorageSupported, storeToLocalStorage} from '../../utils/utils';

const RETAIN_FILTER_ACROSS_SEARCHES = 'retainFilterAcrossSearches';

const getFromLocalStorage = (key: string): string | null =>
    localStorageSupported() ? localStorage.getItem(key) : null;

export const getRetainFilterAcrossSearches = (): boolean => {
    const show = getFromLocalStorage(RETAIN_FILTER_ACROSS_SEARCHES);
    return JSON.parse(show && show !== 'undefined' ? show : 'false');
};


export const setRetainFilterAcrossSearches = (retainFilterAcrossSearches: boolean): void => {
    storeToLocalStorage(RETAIN_FILTER_ACROSS_SEARCHES, JSON.stringify(retainFilterAcrossSearches));
};
